import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
import ViewFiles from "../documents/ViewFiles";
import { useSelector } from "react-redux";
const User = (props) => {
  const { t } = useTranslation();

  const user = useSelector((state)=> state.login)

  const [attributes] = useState([
    {
      type: "select",
      placeholder: "sortType",
      name: "sortType",
      validation: "",
      default: "",
      label: "sortType",
      tab: "generalInfo",
      required: false,
      filter: true,
      view: false,
      add: false,
      update: false,
      filterType: "select",
      apiType: "JSON",
      selectApi: [
        { id: "-1", value: `${t("descending")}` },
        { id: "1", value: `${t("ascending")}` },
      ],
    },
    {
      type: "select",
      placeholder: "title",
      name: "academicTitle",
      tab: "generalInfo",
      validation: "",
      default: "",
      label: "academicTitle",
      required: false,
      view: false,
      filter: false,
      tag: true,
      add: true,
      update: true,
      apiType: "CSV",
      selectApi: "Prof.,Dr.",
    },
    {
      type: "text",
      placeholder: "--",
      name: "fullName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "fullName",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: true,
      upload: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: true,
      upload: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "enterNumber",
      name: "mobileNumber",
      tab: "generalInfo",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      upload: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "enterEmail",
      tab: "generalInfo",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: false,
      upload: true,
      view: true,
      tag: true,
      add: true,
      update: true,
    },
    // {
    //   type: "select",
    //   placeholder: "select",
    //   name: "company",
    //   tab: "generalInfo",
    //   validation: "",
    //   showItem: "organization",
    //   default: user.data.user.company || "",
    //   label: "company",
    //   required: true,
    //   filter: false,
    //   view: false,
    //   tag: true,
    //   add: true,
    //   update: true,
    //   apiType: "API",
    //   selectApi: "company/admin/select",
    // },
    {
      type: "select",
      placeholder: "select",
      name: "department",
      tab: "generalInfo",
      validation: "",
      showItem: "title",
      default: "",
      label: "department",
      required: true,
      filterType: "multiSelect",
      view: true,
      tag: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "department/select",
    },
    {
      type: "select",
      placeholder: "select",
      name: "authorisation",
      tab: "generalInfo",
      validation: "",
      showItem: "",
      default: "admin",
      label: "permissions",
      required: true,
      filter: false,
      view: true,
      tag: true,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi: [
        {id: "admin", value: t("admin")},
        {id: "case-handler", value: t("Case handler")},
        {id: "statistics-viewer", value: t("Statistics viewer")},
        {id: "user-defined", value: t("User defined")},
      ],
    },
    {
      type: "checkbox",
      placeholder: "acceptLogin",
      tab: "generalInfo",
      name: "acceptLogin",
      validation: "",
      showItem: "",
      default: "",
      label: "acceptLogin",
      required: false,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    
    {
      type: "invitation",
      placeholder: "invitation",
      tab: "generalInfo",
      name: "invitationSent",
      validation: "",
      showItem: "invitation",
      default: "",
      label: "invitation",
      required: false,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    {
      type: "select",
      placeholder: "status",
      tab: "generalInfo",
      name: "status",
      validation: "",
      collection: "",
      default: "",
      label: "status",
      required: false,
      view: false,
      tag: false,
      add: false,
      update: true,
      filter: false,
      apiType: "JSON",
      selectApi:[
        {id: "Active", value: t("active")},
        {id: "Inactive", value: t("inactive")}
      ]
    },
    // {
    //   type: "text",
    //   placeholder: "addedBy",
    //   tab: "generalInfo",
    //   name: "addedBy",
    //   validation: "",
    //   showItem: "fullName",
    //   collection: "addedBy",
    //   default: "",
    //   label: "addedBy",
    //   required: false,
    //   view: false,
    //   tag: true,
    //   add: false,
    //   update: false,
    // },
    //genral info end
    //personal info starts
    
    
    // {
    //   type: "select",
    //   apiType: "API",
    //   selectApi: "user/countries",
    //   showItem: "locale",
    //   placeholder: "select",
    //   name: "country",
    //   tab: "personalData",
    //   validation: "",
    //   default: "",
    //   label: "country",
    //   required: false,
    //   filter: false,
    //   view: false,
    //   tag: true,
    //   add: true,
    //   update: true,
    // },
    
    
    {
      type: "select",
      placeholder: "status",
      name: "status",
      tab: "generalInfo",
      validation: "",
      default: "active",
      value: "active",
      label: "status",
      required: false,
      filterType: "select",
      view: false,
      tag: false,
      add: false,
      update: false,
      filter: true,
      apiType: "JSON",
      selectApi: [
        { id: "active", value: t("active") },
        { id: "inactive", value: t("inactive") },
        { id: "all", value: t("all") },
      ],
    },

    {
      type: "image",
      placeholder: "photo",
      name: "photo",
      tab: "generalInfo",
      validation: "",
      default: "",
      label: "photo",
      required: false,
      view: false,
      tag: false,
      add: true,
      update: true,
    },
    
  ]);

  const [advisorAttributes] = useState([
    {
      type: "select",
      placeholder: "sortType",
      name: "sortType",
      validation: "",
      default: "",
      label: "sortType",
      tab: "generalInfo",
      required: false,
      filter: true,
      view: false,
      add: false,
      update: false,
      filterType: "select",
      apiType: "JSON",
      selectApi: [
        { id: "-1", value: `${t("descending")}` },
        { id: "1", value: `${t("ascending")}` },
      ],
    },
    {
      type: "select",
      placeholder: "title",
      name: "academicTitle",
      tab: "generalInfo",
      validation: "",
      default: "",
      label: "academicTitle",
      required: false,
      view: false,
      filter: false,
      tag: true,
      add: true,
      update: true,
      apiType: "CSV",
      selectApi: "Prof.,Dr.",
    },
    {
      type: "text",
      placeholder: "--",
      name: "fullName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "fullName",
      required: false,
      view: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: true,
      upload: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: true,
      upload: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "enterNumber",
      name: "mobileNumber",
      tab: "generalInfo",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      upload: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "enterEmail",
      tab: "generalInfo",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: false,
      upload: true,
      view: true,
      tag: true,
      add: true,
      update: true,
    },
    {
      type: "multiSelect",
      placeholder: "select",
      name: "companies",
      tab: "generalInfo",
      validation: "",
      showItem: "organization",
      default: "",
      label: "companiesAccess",
      required: true,
      filter: false,
      view: false,
      tag: true,
      add: true,
      update: true,
      apiType: "API",
      selectApi: "partner/company/select",
    },
    // {
    //   type: "select",
    //   placeholder: "select",
    //   name: "department",
    //   tab: "generalInfo",
    //   validation: "",
    //   showItem: "title",
    //   default: "",
    //   label: "department",
    //   required: true,
    //   filterType: "multiSelect",
    //   view: true,
    //   tag: true,
    //   add: true,
    //   update: true,
    //   apiType: "API",
    //   selectApi: "department/select",
    // },
    {
      type: "select",
      placeholder: "status",
      tab: "generalInfo",
      name: "status",
      validation: "",
      collection: "",
      default: "",
      label: "status",
      required: false,
      view: false,
      tag: false,
      add: false,
      update: true,
      filter: false,
      apiType: "JSON",
      selectApi:[
        {id: "Active", value: t("active")},
        {id: "Inactive", value: t("inactive")}
      ]
    },
    {
      type: "select",
      placeholder: "select",
      name: "authorisation",
      tab: "generalInfo",
      validation: "",
      showItem: "",
      default: "admin",
      label: "permissions",
      required: true,
      filter: false,
      view: false,
      tag: false,
      add: true,
      update: true,
      apiType: "JSON",
      selectApi: [
        {id: "admin", value: t("admin")},
        {id: "case-handler", value: t("Case handler")},
        {id: "statistics-viewer", value: t("Statistics viewer")},
        {id: "user-defined", value: t("User defined")},
      ],
      customClass: "full"
    },
    {
      type: "checkbox",
      placeholder: "acceptLogin",
      tab: "generalInfo",
      name: "acceptLogin",
      validation: "",
      showItem: "",
      default: "",
      label: "acceptLogin",
      required: false,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    
    {
      type: "invitation",
      placeholder: "invitation",
      tab: "generalInfo",
      name: "invitationSent",
      validation: "",
      showItem: "invitation",
      default: "",
      label: "invitation",
      required: false,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    {
      type: "select",
      placeholder: "status",
      tab: "generalInfo",
      name: "status",
      validation: "",
      collection: "",
      default: "",
      label: "status",
      required: false,
      view: true,
      tag: true,
      add: false,
      update: false,
      filter: false,
      apiType: "JSON",
      selectApi:[
        {id: "Active", value: t("active")},
        {id: "Inactive", value: t("inactive")}
      ]
    },
    // {
    //   type: "text",
    //   placeholder: "addedBy",
    //   tab: "generalInfo",
    //   name: "addedBy",
    //   validation: "",
    //   showItem: "fullName",
    //   collection: "addedBy",
    //   default: "",
    //   label: "addedBy",
    //   required: false,
    //   view: false,
    //   tag: true,
    //   add: false,
    //   update: false,
    // },
    //genral info end
    //personal info starts
    
    
    // {
    //   type: "select",
    //   apiType: "API",
    //   selectApi: "user/countries",
    //   showItem: "locale",
    //   placeholder: "select",
    //   name: "country",
    //   tab: "personalData",
    //   validation: "",
    //   default: "",
    //   label: "country",
    //   required: false,
    //   filter: false,
    //   view: false,
    //   tag: true,
    //   add: true,
    //   update: true,
    // },
    
    
    {
      type: "select",
      placeholder: "status",
      name: "status",
      tab: "generalInfo",
      validation: "",
      default: "active",
      value: "active",
      label: "status",
      required: false,
      filterType: "select",
      view: false,
      tag: false,
      add: false,
      update: false,
      filter: true,
      apiType: "JSON",
      selectApi: [
        { id: "active", value: t("active") },
        { id: "inactive", value: t("inactive") },
        { id: "all", value: t("all") },
      ],
    },

    {
      type: "image",
      placeholder: "photo",
      name: "photo",
      tab: "generalInfo",
      validation: "",
      default: "",
      label: "photo",
      required: false,
      view: false,
      tag: false,
      add: true,
      update: true,
    },
    
  ]);

  // Use the useTranslation hook from react-i18next to handle translations
  // const parkingDuration = totalDuration > 120 ? (days > 0 ? days + `d, ` : ``) + (hours > 0 ? hours + `h, ` : ``) + (minutes + t("m")) : totalDuration.toFixed(0) + ` ` + t("minutes");
  return (
    <Container className="noshadow">
      <ListTable formView="tabs" bulkUplaod={true} {...props} actions={[]} api={(props.user.user?.authorisation === "advisor" && props.user.user?.partner) ? "advisor" : `user`} itemTitle={`fullName`} profileImage={"photo"} shortName={(props.user.user?.authorisation === "advisor" && props.user.user?.partner) ? "advisor" : `user`} viewDetails={false} addPrivilege={true} delPrivilege={true} updatePrivilege={false} selectPrivilege={true} attributes={(props.user.user?.authorisation === "advisor" && props.user.user?.partner) ? advisorAttributes : attributes} formMode="double" popUpUsingId={true} ></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(User);
